'use client'

import { ReactNode } from 'react'

type PropsType = {
  children: ReactNode
}

const Template = ({ children }: PropsType) => {
  return (
    <div className="animate-fadeIn flex w-full flex-1 flex-col" key={Math.random()}>
      {children}
    </div>
  )
}

export default Template
